<section class="bg" *ngIf="false">
<div class="container-fluid bg">
    <div
      class="row"
    >
    <div class="d-flex justify-content-center card m-5 m-auto mt-5 mb-5 pt-5 pb-5" style="border-radius: 10px; padding: 30px; height: 434px;">
      <p class="welcome-text">Login to NRLM SHG Bank Loan Portal</p>
      <p class="pt-1 pb-3 info-text">Please provide the following information to continue</p>
      <form [formGroup]="loginForm"  autocomplete="new-form" (ngSubmit)="submitLogin()" class="d-flex flex-column justify-content-center">
        <div class="form-group">
          <label class=" my-1" for="password my-1">Username <span style="color: red;">*</span></label>
          <input
            type="name"
            class="form-control"
            aria-describedby="userHelp"
            placeholder="Enter Username"
            formControlName="loginId"
            autocomplete="new-name"
          />
        </div>
        <div class="form-group mt-3">
            <label class=" my-1" for="password">Password<span style="color: red;">*</span></label>
          <input
          autocomplete="new-password"
            type="password"
            class="form-control"
            placeholder="Enter Password"
            formControlName="password"
          />
        </div>
          <!-- <div class="d-flex justify-content-end forgot-password">
            <a routerLink="/forgot-password">Forgot Password</a>
          </div> -->
          <div class="security-captcha d-flex justify-content-between mt-3">
              <div class="security-cont">
                <!-- placeholder="Enter Captcha"
                        formControlName="captcha" -->
                  <div class="form-group">
                      <label class=" my-1" for="captcha my-1">Security Code</label>
                      <input
                      autocomplete="off"
                        type="captcha"
                        class="form-control"
                        id="captcha"
                        aria-describedby="userHelp"
                        formControlName="captcha"
                      />
                  </div>
              </div>
                <div class="captcha-cont d-flex justify-content-center pt-4">
                    <div id="captchaId" class="mt-2">
                    </div>
                  <i class="fa fa-refresh m-2" style="cursor: pointer;" aria-hidden="true" (click)="refreshLogin()"></i>

                </div>


          </div>
        <button type="submit" [disabled]="isDisabled" class="btn btn-bg my-3 login-btn-background">LOGIN</button>
      </form>
    </div>
      <div
        class="
          d-flex
          flex-column
          justify-content-center
          align-items-center
          col-lg-6
        "
      >
      </div>
      <div class="
            d-flex
            flex-column
            justify-content-center
            align-items-center
            col-lg-6
          ">
        <h2 class="text-white text-start wel-text">WELCOME</h2>
        <p class="text-white text-start wel-cont">Please login to access your account.</p>
      </div>
    </div>
  </div>
</section>

<section class="bg">
  <div class="container">
    <div class="row align-items-center">
      <div class="col">
        <div class="card border-0 loginCard">
          <div class="card-body">
            <div class="fs-24 fw-500">Login to NRLM SHG Bank Loan Portal</div>
            <p class="fs-12 color-grey">Please provide the following information to continue</p>
            <form [formGroup]="loginForm" autocomplete="new-form" (ngSubmit)="submitLogin()"
            class="d-flex flex-column justify-content-center">
            <div class="form-group mb-3">
              <label class="fs-14 fw-500 my-1" for="password my-1">Username <span style="color: red;">*</span></label>
              <input type="name" class="form-control" aria-describedby="userHelp" placeholder="Enter Username"
                formControlName="loginId" autocomplete="new-name" />
            </div>
            <div class="form-group mb-3">
              <label class="fs-14 fw-500 my-1" for="password">Password<span style="color: red;">*</span></label>
              <input autocomplete="new-password" type="password" class="form-control" placeholder="Enter Password"
                formControlName="password" />
            </div>
            <!-- <div class="d-flex justify-content-end forgot-password">
                  <a routerLink="/forgot-password">Forgot Password</a>
                </div> -->
            <div class="security-captcha d-flex justify-content-between mb-3">
              <div class="security-cont">
                <!-- placeholder="Enter Captcha"
                              formControlName="captcha" -->
                <div class="form-group">
                  <label class="fs-14 fw-500 my-1" for="captcha my-1">Captcha</label>
                  <input autocomplete="off" type="captcha" class="form-control" placeholder="Enter the code" id="captcha" aria-describedby="userHelp"
                    formControlName="captcha" />
                </div>
              </div>
              <div class="captcha-cont d-flex justify-content-center pt-4">
                <div id="captchaId" class="mt-2">
                </div>
                <i class="fa fa-refresh m-2" style="cursor: pointer;" aria-hidden="true" (click)="refreshLogin()" ></i>

              </div>
            </div>
            <button type="submit" [disabled]="isDisabled" class="btn text-white loginBtn mb-2">LOGIN</button>
            <!-- <div class=" text-center"><span class="fs-14 fw-400 pointer" style="color: #2DBE5A;">Forgot Password?</span></div> -->
          </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
